import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, fontSizes, lineHeights, media, radii, space } = theme

export const Section = styled.section`
  box-sizing: border-box;
  width: 100%;
  padding: ${space['spacing-xxxl']} 0;
  background-color: ${colors['neutral-background-default']};

  @media (${media.tablet}) {
    padding: ${space['spacing-giga']} 0;
  }
`

export const Header = styled.div`
  display: grid;
  gap: ${space['spacing-md']};

  h2 {
    margin: 0;
    font-size: ${fontSizes['font-size-mobile-heading-2']};
    line-height: ${lineHeights['font-line-height-md']};
    letter-spacing: -0.72px;
  }

  @media (${media.tablet}) {
    gap: ${space['spacing-xl']};

    h2 {
      font-size: ${fontSizes['font-size-heading-2']};
      line-height: ${lineHeights['font-line-height-sm']};
      letter-spacing: -0.96px;
    }
  }
`

export const Highlight = styled.span`
  display: inline;
  color: ${colors['blue-background-strong-default']};
  font-weight: 600;

  @media (${media.tablet}) {
    color: ${colors['pink-text-contrast']};
  }
`

export const Introduction = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};

  p {
    margin: 0;
  }
`

export const CardList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['spacing-sm']};
  margin-top: ${space['spacing-xl']};

  @media (${media.tablet}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: ${space['spacing-md']};
    margin-top: ${space['spacing-xxl']};
  }

  @media (${media.desktop}) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: ${space['spacing-md']};
    margin-top: ${space['spacing-xl']};
  }
`

export const Card = styled.article`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
  min-height: 260px;
  padding: ${space['spacing-md']};
  border-radius: ${radii['corner-radius-lg']};
  background-color: ${colors['blue-background-strong-default']};

  h3,
  p {
    margin: 0;
  }

  h3 {
    font-size: ${fontSizes['font-size-mobile-heading-5']};
  }

  p {
    line-height: ${lineHeights['font-line-height-lg']};
  }

  @media (${media.tablet}) {
    min-height: 304px;
  }

  @media (${media.desktop}) {
    min-height: 264px;
  }
`

export const IconWrapper = styled.span`
  display: inline-flex;
  width: ${space['spacing-xxl']};
  height: ${space['spacing-xxl']};
  margin-bottom: ${space['spacing-sm']};

  svg {
    width: 100%;
    height: 100%;
  }
`

export const Cta = styled.div`
  width: 100%;

  .ds-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: ${space['spacing-mega']};
    margin-top: ${space['spacing-xl']};
    padding: 0 ${space['spacing-sm']};
    border-radius: ${radii['corner-radius-pill']};
    background-color: ${colors['blue-background-strong-default']};
    transition: background-color 180ms ease;

    &:hover {
      background-color: ${colors['blue-background-strong-hover']};
    }

    &:focus-visible {
      outline: 2px solid ${colors['neutral-text-default']};
      outline-offset: 3px;
    }
  }

  @media (${media.desktop}) {
    .ds-button {
      width: 230px;
      margin: ${space['spacing-xl']} auto 0;
    }
  }

`
